import { Injectable } from '@angular/core';

import { IBetslipCalculatorOverrides } from '../../bet-generation/models';
import { ComboSlipType } from '../../bet-generation/slip-type';
import { AccaBoostToken } from '../../reward-tokens/reward-tokens.model';
import { byAccaPriority } from '../../reward-tokens/services/reward-tokens.utils';
import { AccaBoostTokenValidator } from '../../reward-tokens/services/validators/acca-boost-token-validator.service';
import { TokenValidationInput } from '../../reward-tokens/services/validators/criteria-validator-base.service';

@Injectable()
export class UpsellOverridesService {
    constructor(private accaBoostTokenValidator: AccaBoostTokenValidator) {}

    getOverrides(context: TokenValidationInput, accaTokens: AccaBoostToken[]): IBetslipCalculatorOverrides {
        const eligibilityTokens = accaTokens
            .filter((token) => {
                return this.accaBoostTokenValidator.validate(token, context).isEligible;
            })
            .sort(byAccaPriority);

        return {
            slipOverrides: [
                {
                    system: new ComboSlipType(),
                    pickIds: [],
                    rewardToken: { token: eligibilityTokens[0] },
                },
            ],
            pickOverrides: {},
        };
    }
}
